export const getLowerCaseLabel = (index) => {
    let label = '';
    let num = index;

    while (num >= 0) {
        label = String.fromCharCode((num % 26) + 97) + label;
        num = Math.floor(num / 26) - 1;
    }

    return label;
}